"use client";

import { useAuth } from "@clerk/nextjs";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { toast } from "@/components/ui/sonner";
import { usePathname } from "@/i18n/navigation";

export const SIGN_OUT_TOAST_KEY = "sign-out-toast";

export const SignOutToast = () => {
  const t = useTranslations("header");
  const { isLoaded, isSignedIn } = useAuth();
  const pathname = usePathname();

  useEffect(() => {
    if (!isLoaded || isSignedIn) {
      return;
    }

    if (sessionStorage.getItem(SIGN_OUT_TOAST_KEY) !== pathname) {
      return;
    }

    sessionStorage.removeItem(SIGN_OUT_TOAST_KEY);
    toast.success(t("signOutSuccess"));
  }, [isLoaded, isSignedIn, pathname, t]);

  return null;
};
